/**
 * Wallet Configuration for Reown AppKit
 *
 * Defines WalletConnect project ID and network mappings.
 */

// WalletConnect Project ID from Reown Cloud
export const WALLETCONNECT_PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'be0e1663a7a20b809e58b73d00e85f11';

// Network ID to chain mapping for backend compatibility
export const NETWORK_TO_CHAIN_ID: Record<string, number> = {
  ethereum: 1,
  polygon: 137,
  arbitrum: 42161,
  optimism: 10,
  base: 8453,
  bsc: 56,
  avalanche: 43114,
  blast: 81457,
  zksync: 324,
  linea: 59144,
};

// Reverse mapping: chain ID to network name
export const CHAIN_ID_TO_NETWORK: Record<number, string> = Object.entries(NETWORK_TO_CHAIN_ID).reduce(
  (acc, [network, chainId]) => ({ ...acc, [chainId]: network }),
  {} as Record<number, string>
);
